import styled from 'styled-components';

import { Card } from '..';

export const StandardCard = styled(Card)`
  padding: ${props => props.theme.space.s5};
  background-color: ${props => props.theme.colors.white};
`;
